module.exports = __webpack_public_path__ + "static/media/NAA-TopEmployers-Logo-2022.5a0fd85c.png";